// sections/fifty-fifty-banner.liquid includes this file once per section, and a second top-level
// class declaration in a classic script throws, so the class is block-scoped and defined once.
if (!customElements.get('card-slider-component')) {
  class CardSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.desktopSlider = this.querySelector('.card-slider--desktop .card-slider__track');
      this.mobileSlider = this.querySelector('.card-slider--mobile .card-slider__track');
      this.currentDesktopIndex = 0;
      this.currentMobileIndex = 0;
      this.autoplayIntervals = new Map();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
   
      if (this.desktopSlider) {
        this.initSlider(this.desktopSlider, 'desktop');
      }
      if (this.mobileSlider) {
        this.initSlider(this.mobileSlider, 'mobile');
      }
    }
  
 
    initSlider(slider, type) {
      const slides = slider.querySelectorAll('.card-slider__slide');
   
      if (slides.length <= 1) return;
 
      const dotsContainer = slider.closest('.card-slider').querySelector('.card-slider__dots');
      const dots = dotsContainer ? dotsContainer.querySelectorAll('.card-slider__dot') : [];
 
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goToSlide(slider, index, dots, type);
        });
      });
 
      slider.addEventListener('scroll', () => {
        this.updateDotsOnScroll(slider, dots, type);
      });
 
      this.addDragToScroll(slider, slides, dots, type);
 
      const autoplayEnabled = this.dataset.autoplay === 'true';
      if (autoplayEnabled) {
        this.setupAutoplay(slider, slides, dots, type);
      }
    }
 
    goToSlide(slider, index, dots, type) {
      const slides = slider.querySelectorAll('.card-slider__slide');
      if (index < 0 || index >= slides.length) return;
 
      const slideWidth = slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(slider).gap) || 0;
      const scrollDistance = (slideWidth + gap) * index * (getComputedStyle(slider).direction === 'rtl' ? -1 : 1);
    
      slider.scrollTo({
        left: scrollDistance,
        behavior: this.reducedMotion.matches ? 'instant' : 'smooth'
      });
 
      this.updateDots(dots, index);
   
      if (type === 'desktop') {
        this.currentDesktopIndex = index;
      } else {
        this.currentMobileIndex = index;
      }
    }
 
    updateDotsOnScroll(slider, dots, type) {
      const slides = slider.querySelectorAll('.card-slider__slide');
      if (slides.length === 0) return;
 
      const slideWidth = slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(slider).gap) || 0;
      const scrollLeft = slider.scrollLeft;
      const currentIndex = Math.round(Math.abs(scrollLeft) / (slideWidth + gap));

      this.updateDots(dots, currentIndex);
   
      if (type === 'desktop') {
        this.currentDesktopIndex = currentIndex;
      } else {
        this.currentMobileIndex = currentIndex;
      }
    }
 
    updateDots(dots, activeIndex) {
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === activeIndex));
        if (index === activeIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
 
    addDragToScroll(slider, slides, dots, type) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let isDragging = false;
 
      const images = slider.querySelectorAll('img');
      images.forEach((img) => {
        img.setAttribute('draggable', 'false');
      });
 
      const anchors = slider.querySelectorAll('a');
      anchors.forEach((anchor) => {
        anchor.setAttribute('draggable', 'false');
      });
 
      slider.addEventListener('mousedown', (e) => {
        e.preventDefault(); 
        isDown = true;
        isDragging = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
      });
 
      slider.addEventListener('mouseleave', () => {
        if (isDown) {
          isDown = false;
          slider.style.cursor = 'grab';
        }
      });
 
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });
 
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        isDragging = true;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
 
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          isDragging = false; 
        }
      });
 
      slider.style.cursor = 'grab';
    }
 
    setupAutoplay(slider, slides, dots, type) {
      const speed = parseInt(this.dataset.speed || '5') * 1000;
      const container = slider.closest('.card-slider');
      const button = container.querySelector('.card-slider__autoplay');
      let paused = this.reducedMotion.matches;
      const syncButton = () => button?.setAttribute('aria-pressed', String(!paused));
      const stop = () => this.stopAutoplay(type);
      const start = (explicit = false) => {
        stop();
        if (paused || !this.isConnected || (!explicit && container.contains(document.activeElement))) return;
        this.autoplayIntervals.set(type, setInterval(() => {
          if (!container.getClientRects().length) return;
          const currentIndex = type === 'desktop' ? this.currentDesktopIndex : this.currentMobileIndex;
          this.goToSlide(slider, (currentIndex + 1) % slides.length, dots, type);
        }, speed));
      };
      button?.addEventListener('click', () => {
        paused = !paused;
        syncButton();
        paused ? stop() : start(true);
      });
      container.addEventListener('mouseenter', stop);
      container.addEventListener('mouseleave', () => start());
      container.addEventListener('focusin', stop);
      container.addEventListener('focusout', () => setTimeout(start, 0));
      slider.addEventListener('touchstart', stop, { passive: true });
      slider.addEventListener('touchend', () => setTimeout(start, 1000), { passive: true });
      syncButton();
      start();
    }

    stopAutoplay(type) {
      this.autoplayIntervals.forEach((timer, key) => {
        if (type && type !== key) return;
        clearInterval(timer);
        this.autoplayIntervals.delete(key);
      });
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }
 
  customElements.define('card-slider-component', CardSliderComponent);
}
